<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <el-form-item  prop="mccList">
          <el-select v-model="queryParams.mccList" filterable placeholder="国家" @change="search" clearable multiple >
            <el-option v-for="item in countrys" :key="item.countryCode" :value="item.mcc" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="billDate">
          <el-input v-model="queryParams.billDate" placeholder="账单日期如YYYYMM"  @keyup.enter.native="search" clearable></el-input>
        </el-form-item>
        <el-form-item  prop="dateRange">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="dateRange"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
          <el-button type="success" icon="el-icon-pie-chart"  @click="showStatsReport">统计报表</el-button>
        </el-form-item>
    </el-form>
    <div class="stats-container" style="margin-bottom: 16px; padding: 10px; background: #f5f7fa; border-radius: 4px;">
      <span style="font-weight: bold; color: #1890ff;">总用量：</span>
      <span style="color:red">{{ totalUsage || '0MB' }}</span>
    </div>
    <el-table :data="tabeData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="startTime"  label="开始时间" align="center"></el-table-column>
      <el-table-column prop="endTime" v-if="channel != 'cmlink'"  label="结束时间" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="useFlow" label="用量" align="center" width="260"></el-table-column>
      <el-table-column prop="country" label="国家" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operatorCode" label="运营商" align="center" width="330" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="billMonth" label="账单日期" align="center" width="160"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
      />
    <!-- 流量统计报表弹窗 -->
    <el-dialog
      title="历史日流量"
      :visible.sync="statsDialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="stats-dialog-content">
        <div class="date-range-picker" style="display: flex; align-items: center; margin-bottom: 16px;">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="statsDateRange"
            @change="getStatsData"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin-right: 16px;"
            :picker-options="datePickerOptions"
          >
          </el-date-picker>
          <el-radio-group v-model="timeDimension" @change="getStatsData">
            <el-radio-button label="day">日</el-radio-button>
            <el-radio-button label="month">月</el-radio-button>
          </el-radio-group>
        </div>
        <div class="flow-stats">
          <h3 style="font-weight: bold; font-size: 18px;">{{iccid}}</h3>
        </div>
        <div id="flowChart" class="chart-container" style="width: 100%; height: 400px;"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { internationalFlowRecords , countryList , internationalFlowSum ,lineChartCardSession} from "@/api/international.js"; //订单列表

import * as echarts from 'echarts';
export default {
  props: {
    iccid: {
      type: [String]
    },
    channel: {
      type: [String]
    }
  },
  watch: {
    iccid() {
      this.queryParams.iccid = this.iccid
      this.search();
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  data() {
    let selectDateTemp = null;
    return{
      total:0,
      page:1,
      pageSize:20,
      tabeData:[],
      totalUsage:'0MB',
      dateRange: [],
      countrys:[],
      queryParams:{
        iccid:this.iccid,
        billDate:undefined,
        mccList:[],
      },
      // 日期选择器配置
      datePickerOptions: {
        // 1. 监听日期点击事件
        onPick: (date) => {
          //开始鼠标在第一第二  都是min的值
          // date.minDate 和 date.maxDate 是 Date 对象
          // 如果只选了一个，minDate 有值，maxDate 为 null
          // 如果选完了两个，minDate 和 maxDate 都有值
          if (date.minDate && !date.maxDate) {
            // 选中了第一个日期
            selectDateTemp = date.minDate;
          } else {
            // 选中了第二个日期（或者清空了），清空临时变量
            selectDateTemp = null;
          }
        },
        disabledDate: (time) => {
          const thirtyDays = 30 * 24 * 60 * 60 * 1000;
          const timeStamp = time.getTime();
          // 判断临时变量是否有值
          if (selectDateTemp) {
            const selectTime = selectDateTemp.getTime();
            // 只能选前后 30 天
            return (
              timeStamp < selectTime - thirtyDays || 
              timeStamp > selectTime + thirtyDays
            );
          }
          return false;
        }
      },
      // 统计报表相关
      statsDialogVisible: false,
      statsDateRange: [],
      timeDimension: 'day', // day或month
      totalFlow: '0MB',
      flowChart: null,
      statsData: []

    }
  },
  methods: {
    // 获取话单数据
    initData(){
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalFlowRecords(params).then(res =>{
        this.total = res.data.data.total;
        this.tabeData = res.data.data.records;
      })
    },
    initCountryData(){
      countryList().then(res =>{
        this.countrys = res.data.data;
      })
    },
    initSumFlow(){
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange)
      };
      internationalFlowSum(params).then(res =>{
        this.totalUsage = res.data.data
      })
    },
    search(){
      this.initSumFlow()
      this.initData()
    },
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    // 打开统计报表弹窗
    showStatsReport() {
      this.statsDialogVisible = true;
      this.statsDateRange = [];
      this.type = 'day'
      // 等待DOM更新后初始化图表
      this.$nextTick(() => {
        this.initFlowChart();
        this.getStatsData();
      });
    },
    // 获取统计数据
    getStatsData() {
      let params = {
        ...this.addDateRange({ iccid: this.iccid }, this.statsDateRange),
        type: this.timeDimension
      };
      // 模拟数据 - 实际应替换为真实API调用
      setTimeout(() => {
        lineChartCardSession(params).then(res=>{
          const dates = res.data.data.timeList 
          const values = res.data.data.monthList
          this.statsData = { dates , values };
          this.updateFlowChart();
        })
       
      }, 500);
    },
    // 初始化流量图表
    initFlowChart() {
      if (this.flowChart) {
        this.flowChart.dispose();
      }
      this.flowChart = echarts.init(document.getElementById('flowChart'));
      this.updateFlowChart();
    },
    // 更新流量图表
    updateFlowChart() {
      if (!this.flowChart || !this.statsData.dates) return;
      
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            return params[0].name + '<br/>' + '流量: ' + params[0].value.toFixed(2) + ' MB';
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '20%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.statsData.dates,
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          name: 'MB',
          min: 0,
          max: function(value) {
            // 动态计算y轴最大值，确保有足够空间显示标签
            return Math.ceil(value.max * 1.3);
          }
        },
        series: [
          {
            name: '流量',
            type: 'bar',
            data: this.statsData.values,
            itemStyle: {
              color: '#1890ff'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return params.value.toFixed(2) + ' MB';
              },
              fontSize: 10,
              color: '#333'
            },
            barWidth: '60%',
            barGap: '20%',
            barCategoryGap: '30%'
          }
        ]
      };
      
      this.flowChart.setOption(option);
    },
    // 监听窗口大小变化，调整图表大小
    handleResize() {
      if (this.flowChart) {
        this.flowChart.resize();
      }
    }
  },
  created() {
    this.search()
    this.initCountryData();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.flowChart) {
      this.flowChart.dispose();
    }
  }
};
</script>



